<template>
  <el-card class="box-card">
    <div class="main">
      <el-form inline class="global-form">
        <el-form-item prop="projectName">
          <el-input v-model="searchForm.projectName" clearable placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item prop="checkoutNum">
          <el-input v-model="searchForm.checkoutNum" clearable placeholder="请输入出库单号"></el-input>
        </el-form-item>
        <el-form-item prop="checkoutUser">
          <el-date-picker v-model="dateRange" type="daterange" range-separator="-" value-format="yyyy-MM-dd"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="dateRangeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <el-button class="mb10" @click="$router.push('/property/materialexwarehouse/add')" type="primary"
        icon="el-icon-plus" v-show="$ButtonShow('YCT_ADD_01')">新增出库</el-button>

      <el-table v-loading="loading" :data="tableData" class="global-table">
        <el-table-column label="项目名称" show-overflow-tooltip prop="projectName"></el-table-column>
        <el-table-column label="出库单号" show-overflow-tooltip prop="checkoutNum"></el-table-column>
        <el-table-column label="出库日期" show-overflow-tooltip prop="checkoutDate"></el-table-column>
        <el-table-column label="出库种类数量" show-overflow-tooltip prop="materialNum"></el-table-column>
        <el-table-column label="出库物料数量" show-overflow-tooltip prop="materialStockNum"></el-table-column>
        <el-table-column label="创建人" show-overflow-tooltip prop="createUserName"></el-table-column>
        <el-table-column label="创建时间" show-overflow-tooltip prop="ctime"></el-table-column>
        <el-table-column label="操作" fixed="right" width="120px">
          <template v-slot="{ row }">
            <el-button type="text"
              @click="$router.push('/property/materialexwarehouse/detail?id=' + row.id)">查看</el-button>
            <el-button type="text" @click="onDownLoad(row.id)" v-show="$ButtonShow('YCT_SEL_04')">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
        :page-size.sync="size" :total="total">
      </global-pagination>
    </div>
  </el-card>
</template>

<script>

export default {
  name: 'Exwarehouse',
  components: {
  },
  data() {
    return {
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      dateRange: [],
      searchForm: {
        projectName: '', // 项目名称
        checkoutNum: '', // 出库单号
        startTime: '', // 出库日期
        endTime: '' // 出库日期
      }
    }
  },
  computed: {
  },
  created() {
    if (this.$route.query.projectName || this.$route.query.startTime && this.$route.query.endTime) {
      this.searchForm.projectName = this.$route.query.projectName
      this.searchForm.startTime = this.$route.query.startTime
      this.searchForm.endTime = this.$route.query.endTime
      this.dateRange = [this.$route.query.startTime, this.$route.query.endTime]
    }

    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.material.selectYhCheckoutByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    dateRangeChange(date) {
      if (date) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    // 下载
    onDownLoad(id) {
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$axios.downloadFile(this.$apis.material.exportExcel2, {
        id: id
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  padding: 0px 10px;
}
</style>
